import {autoDrawMask} from "olcs/print/drawCesiumMask";
import {computeRectangle} from "olcs/print/computeRectangle";
import {getCesiumScene} from "@/modules/cesium/cesium";
import {getBySelector} from "@/helpers/element-helper";
import {takeScreenshot} from "olcs/print/takeCesiumScreenshot";

export function initPrintCesium() {
    const scene = getCesiumScene()
    autoDrawMask(scene, () => scalingOptions().scaling);
}

export function downloadPrintCesium() {
    const scene = getCesiumScene()
    const r = scalingOptions();
    takeScreenshot(scene, r).then(value => {
        const a = document.createElement("a");
        a.download = getBySelector('#slcPrintCesiumFileName').value + ".png";
        a.href = value;
        a.click();
        a.remove()
    })
}

export function scalingOptions() {
    const scene = getCesiumScene()
    const printValue = getBySelector('#slcPrintCesiumPosition').value;
    const canvas = scene.canvas;
    const v = Math.min(canvas.width, canvas.height);
    switch (printValue) {
        case 'portrait':
            return computeRectangle(canvas, v / 4, v / 2);
        default:
            return computeRectangle(canvas, v / 2, v / 4);
    }
}

export function clearPrintCesium() {
    const scene = getCesiumScene()
    if(scene) {
        autoDrawMask(scene, null)
    }
}
